import script from "./FormSelectOfficePerson.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormSelectOfficePerson.vue?vue&type=script&lang=ts&setup=true"

import "./FormSelectOfficePerson.vue?vue&type=style&index=0&id=adb4ad02&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adb4ad02"]])

export default __exports__